import React, { useEffect, memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';
import styles from './WallpaperShortcut.module.less';
import { PCStoreJsBridge } from '../nativeapi';
import { logging } from '../actions/log';
import { createShortcut } from '../actions/layout';
import { localSetItem } from '../utils/utils';
import Toast from '../components/Toast/Toast';
import layout from '../reducers/layout';

const SelectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectWallpaper = createSelector(
  state => state.layout,
  layout => layout.wallpaperShortcut,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(SelectLogInfo);
  const wallpaperInfo = useSelector(SelectWallpaper);

  useEffect(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Desktop',
        label: '',
        param2: {
          source: wallpaperInfo.loginInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          // wallpaperId: wallpaperInfo.wallpaperInfo.wallpaperId,
          wptype: '1',
        },
      }),
    );
  }, []);

  const handleClose = type => {
    if (type) {
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Desktop_N',
          label: '',
          param2: {
            source: wallpaperInfo.loginInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            // wallpaperId: wallpaperInfo.wallpaperInfo.wallpaperId,
            wptype: '1',
          },
        }),
      );
    }

    dispatch(
      createShortcut({
        tag: false,
        loginInfo: {},
        wallpaperInfo: {},
      }),
    );
  };

  const handleCreateShortcut = () => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Desktop_Y',
        label: '',
        param2: {
          source: wallpaperInfo.loginInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          // wallpaperId: wallpaperInfo.wallpaperInfo.wallpaperId,
          wptype: '1',
        },
      }),
    );

    PCStoreJsBridge.wallpaperDesktop()
      .then(res => {
        Toast.success({ content: '壁纸中心入口创建成功' });
      })
      .catch(err => {
        Toast.success({ content: '壁纸中心入口创建失败' });
      });
    dispatch(
      createShortcut({
        tag: false,
        loginInfo: {},
        wallpaperInfo: {},
      }),
    );
  };

  return (
    <div className={styles.wallpaper_shortcut_bg}>
      <div className={styles.wallpaper_shortcut}>
        <div className={styles.header}>
          <span className={styles.title}>温馨提示</span>
          <span
            className={`${styles.close} iconfont icon-close`}
            onClick={() =>
              dispatch(
                createShortcut({
                  tag: false,
                  loginInfo: {},
                  wallpaperInfo: {},
                }),
              )
            }
          />
        </div>
        <div className={styles.message}>
          是否在桌面创建壁纸频道快捷入口，快速访问壁纸频道，好看的壁纸天天有
        </div>
        <div className={styles.btn_operation}>
          <div className={styles.btn} onClick={() => handleClose(true)}>
            取消
          </div>
          <div className={styles.btn_create} onClick={() => handleCreateShortcut()}>
            创建
          </div>
        </div>
      </div>
    </div>
  );
});
